module.exports = __webpack_public_path__ + "img/zz-row-seven.df7e088f.svg";